import axios from 'axios';

class ArticleService {
    static GetArticlesForVFair(vFairId) {
        return axios({
            method: 'GET',
            url: `${
                process.env.VUE_APP_API_URL
            }v1/organization/Article?vFairId=${vFairId}&limit=99999`,
        })
            .then(result => {
                return result.data.items;
            })
            .catch(() => {
                return [];
            });
    }
}

export default ArticleService;
